export default {"src":"/_next/static/media/roadmap2.0f785a77.svg","height":34,"width":34};